import fr from 'facet-rest';
import BaseOverride from 'Overrides/OnboardingStep/BaseOverride';
import { overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import BlueBoxWithText from 'Components/ComponentLibrary/Components/Uncategorized/BlueBoxWithText';
import BigPicklistControl from 'Components/ComponentLibrary/Components/Inputs/Picklist/BigPicklistControl';

const OnboardingWelcomeOverride = fr.metaOverride({ base: BaseOverride })
  .typeOverride('multipicklist', {
    _component: () => BigPicklistControl,
    _customProps: {
      multiple: true,
      testName: 'qualitative-question',
    },
  })
  .typeOverride('picklist', {
    _component: () => BigPicklistControl,
    _customProps: {
      multiple: false,
      testName: 'qualitative-question',
    },
  })
  .nameOverride(['feelingDescription', 'optionOtherDescription'], { multiline: true, _hideLabel: true, rows: 10 })
  .nameOverride('description', {
    _component: () => BlueBoxWithText,
  }, overrideReadOnly);


export default OnboardingWelcomeOverride;
